// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"095a499d","453":"82686c6d","455":"df62b87c"}[chunkId] + ".chunk.js";
};